export default __webpack_public_path__ + "static/media/red_back.3c9f6d28.svg";